<template>
  <div class="offcie-warp">
    <div class="title-warp">
      <div class="pic-warp">
        <div class="pic" style="background-image:url('static/images/ex_pic13.jpg');"></div>
        <h1>{{zoneDetail.name}}</h1>
        <h4>执业证号：{{zoneDetail.code}}</h4>
        <h4>通讯地址：{{zoneDetail.address}}</h4>
      </div>
      <div class="number-warp">
        <div class="inner-warp">
          <div class="number">{{zoneDetail.todaynumber}}</div>
          <p>今日业务量</p>
        </div>
        <div class="inner-warp">
          <div class="number">{{zoneDetail.allnumber}}</div>
          <p>业务总量</p>
        </div>
        <div class="inner-warp">
          <div class="number">{{zoneDetail.personnel}}</div>
          <p>公证员</p>
        </div>
        <div class="inner-warp">
          <div class="number">{{zoneDetail.company}}</div>
          <p>办证室</p>
        </div>
      </div>
    </div>
    <div class="personnel-list-warp">
      <h3>今日在岗公证人（{{zoneDetail.personnelList.length}}）人</h3>
      <div class="pf-iner-box">
        <personnel-list
        :listArr='zoneDetail.personnelList'
        ></personnel-list>
      </div> 
    </div>
    <div class="office-list-warp">
      <div class="pf-iner-box">
        <h3>办证室（{{zoneDetail.companyList.length}}）间</h3>
        <office-list
          :listArr='zoneDetail.companyList'
        ></office-list>
      </div>  
    </div>
    <a href="#/index/aside" class="go-back" @click="goback(true)">&times;</a>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import personnelList from '@/components/personnel-list'
  import officeList from '@/components/office-list'
  import VIscroll from 'viscroll'
  export default {
    components: { VIscroll, personnelList, officeList },
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
        'zoneDetail'
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
        'AgetBack'
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      goback (swit) {
        this.AgetBack(swit)
        window.history.back()
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
      console.log(this.zoneDetail)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">

  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .offcie-warp {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 900px;
    height: 700px;
    padding: 35px 35px 50px 35px;
    border-radius: 6px;
    border: 2px solid rgba(#5389d8, .9);
    background: rgba($brand, .9);
    .title-warp {
      width: 100%;
      height: 150px;
      color: $white;
      border-bottom: 1px solid $gray-lighter;
      @include clearfix;
    }
    .pic-warp {
      position: relative;
      height: 100%;
      width: 50%;
      padding-left: 150px;
      float: left;
      .pic {
        position: absolute;
        left: 0;
        top: 0;
        width: 130px;
        height: 130px;
        background: url('/static/images/ex_pic13.jpg') no-repeat center center;
        background-size: 100% auto; 
      }
      h1, h4 {
        margin: 0 0 15px 0;
        line-height: 100%;
        font-weight: normal;
      }
      h1 {
        margin-top: 5px;
        margin-bottom: 30px;
      }
      h4 {
        font-size: 15px;
      }
    }
    .number-warp {
      width: 50%;
      height: 100%;
      float: left;
      @include clearfix;
      .inner-warp {
        width: 25%;
        height: 100%;
        margin-top: 5px;
        text-align: center;
        float: left;
        p {
          margin: 0;
        }
      }
      .number {
        width: 75px;
        height: 75px;
        margin-bottom: 15px;
        display: inline-block;
        border-radius: 50%;
        text-align: center;
        line-height: 75px;
        color: $brand-green;
        font-size: 20px;
        background: $white;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .personnel-list-warp {
      position: relative;
      width: 40%;
      height: calc(100% - 150px);
      float: left;
      overflow: hidden;
      h3 {
        color: $white;
      }
    }
    .office-list-warp {
      position: relative;
      width: 60%;
      height: calc(100% - 150px);
      float: left;
      overflow: hidden;
      h3 {
        color: $white;
      }
    }
    .pf-iner-box {
      width: 100%;
      height: 400px;
    }
  }
  .go-back {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    margin: auto;
    width: 30px;
    height: 30px;
    color: $white;
    font-size: 15px;
    text-align: center;
    line-height: 26px;
    border: 1px solid $white;
    border-radius: 50%;
    display: block;
  }
</style>




// WEBPACK FOOTER //
// office.vue?5b87efe8